import * as React from 'react'
import { useMediaQuery } from 'react-responsive'

type AppContextType = {
  drawerOpen: boolean
  toggleDrawer: () => void
  drawerOpen2: boolean
  toggleDrawer2: (defaultOpen?: boolean) => void
  isTabletOrMobile: boolean
  isLive: boolean
  setIsLive: React.Dispatch<React.SetStateAction<boolean>>
  connected: boolean
  setConnected: React.Dispatch<React.SetStateAction<boolean>>
  onDrawer2Close: (() => void) | null
  setOnDrawer2Close: React.Dispatch<React.SetStateAction<(() => void) | null>>
}

export const AppContext = React.createContext<AppContextType>({
  drawerOpen: false,
  toggleDrawer: () => null,
  drawerOpen2: false,
  toggleDrawer2: () => null,
  isTabletOrMobile: false,
  isLive: false,
  setIsLive: () => null,
  connected: false,
  setConnected: () => null,
  onDrawer2Close: null,
  setOnDrawer2Close: () => null
})

export const useAppContext = () => React.useContext(AppContext)

const AppProvider: React.FC<{}> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const [drawerOpen2, setDrawerOpen2] = React.useState(false)
  const [connected, setConnected] = React.useState<boolean>(false)
  const [isLive, setIsLive] = React.useState<boolean>(false)
  const [onDrawer2Close, setOnDrawer2Close] = React.useState<(() => void) | null>(null)

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 40em)' })

  function toggleDrawer() {
    setDrawerOpen(!drawerOpen)
  }
  function toggleDrawer2(defaultOpen = false) {
    if (defaultOpen) {
      setDrawerOpen2(defaultOpen)
    } else {
      setDrawerOpen2((prev) => {
        const newState = !prev
        if (!newState && onDrawer2Close) {
          onDrawer2Close()
        }
        return newState
      })
    }
  }

  return (
    <AppContext.Provider
      value={{
        drawerOpen,
        toggleDrawer,
        isTabletOrMobile,
        drawerOpen2,
        toggleDrawer2,
        connected,
        setConnected,
        isLive,
        setIsLive,
        onDrawer2Close,
        setOnDrawer2Close
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default AppProvider
